<template>
  <el-row>
    <el-col :span="24" class="component-container">
      <div class="box-component">
        <p class="fat-text" style="margin-bottom: 0">
          {{ $t("stageTwoOne.instructionMessage1") }}
        </p>
        <p class="fat-text" style="margin-bottom: 0">
          {{ $t("stageTwoOne.instructionMessage2") }}
        </p>
        <p class="fat-text" style="margin-bottom: 0">
          {{ $t("stageTwoOne.instructionMessage3") }}
        </p>
        <p class="fat-text" style="margin-bottom: 0">
          {{ $t("stageTwoOne.instructionMessage4") }}
        </p>
        <img
          class="poly-instruction"
          src="/src/assets/images/katto-esimerkki.svg"
        />
      </div>
    </el-col>
  </el-row>

  <el-row>
    <el-col :span="24" class="component-container">
      <div class="box-component">
        <p class="fat-text">{{ $t("stageTwoOne.instructionMessage5") }}</p>
        <div
          class="polygon-area"
          :key="index"
          v-for="(polygon, index) in polygons"
        >
          <p>{{ $t("general.polygon") }} {{ index + 1 }}</p>
          <button @click="deletePolygon(Number(index))" class="delete-polygon">
            <img src="../assets/icons/icon-sulje.svg" />
          </button>
        </div>
        <div class="polygon-area" v-if="polygons.length === 0">
          <p style="opacity: 0.4">{{ $t("stageTwoOne.noPolygonsFound") }}</p>
        </div>
      </div>
    </el-col>
  </el-row>

  <el-row>
    <el-col :span="24" class="component-container">
      <div class="box-component">
        <p class="fat-text" style="margin-bottom: 1rem">
          {{ $t("stageTwoOne.cantFindHouse") }}
        </p>
        <p>{{ $t("stageTwoOne.roofArea") }} m<sup>2</sup></p>
        <el-input @input="manualInput" type="number" v-model="input"></el-input>
      </div>
    </el-col>
  </el-row>
</template>

<script lang="ts" setup>
import { ref } from "vue";
import { get } from "@vueuse/core";
import type { Polygon } from "@/types";

defineProps<{
  polygons: Polygon[][];
}>();

const emit = defineEmits(["deletePolygon", "manualAreaChange"]);

const input = ref("");

function deletePolygon(index: number) {
  emit("deletePolygon", index);
}

function manualInput() {
  emit("manualAreaChange", get(input));
}
</script>
